export function LoadingScreen() {
  return (
    <div className="shell-grid flex min-h-screen items-center justify-center px-6 text-slate-100">
      <div className="glass-panel rounded-[28px] border border-white/10 px-8 py-6 text-sm uppercase tracking-[0.32em] text-sky-200">
        Securing workspace...
      </div>
    </div>
  );
}